/* eslint-disable no-shadow */
export enum Sections {
	Personal = 'Personal',
	Business = 'Business',
	Wealth = 'Wealth',
	Estate = 'Estate'
}

export enum FlightPlanSections {
	Personal = 1,
	Business,
	Wealth,
	Estate,
	Health,
	Development
}

export enum FlightPlanStatus {
	NotStarted = 'Not Started',
	InProgress = 'In Progress',
	Completed = 'Completed',
	NotApplicable = 'Not Applicable'
}

export enum QuestionTypes {
	RadioList = 'RadioList',
	CheckList = 'CheckList',
	Slider = 'Slider',
	DragAndDrop = 'DragAndDrop'
}

export enum MessageTypes {
	Information = 'information',
	Error = 'error'
}

export enum QuestionUniqueNames {
	// Client Profile Questions
	AgeGroup = 'AgeGroup',
	IsBusinessOwner = 'IsBusinessOwner',

	// Personal Questions
	WorryAboutMoneyFrequency = 'WorryAboutMoneyFrequency',
	FinanciallySecureAboutFuture = 'FinanciallySecureAboutFuture',
	FinancesOutOfControl = 'FinancesOutOfControl',
	HaveEnoughEmergencyMoney = 'HaveEnoughEmergencyMoney',
	WorryAboutFamilyWouldDo = 'WorryAboutFamilyWouldDo',
	FinancialConcernsAreAffectingMyHealth = 'FinancialConcernsAreAffectingMyHealth',
	ConfidenceInMakingComplexFinancialDecisions = 'ConfidenceInMakingComplexFinancialDecisions',
	SpendingHabits = 'SpendingHabits',
	NetIncomeSaveEachMonth = 'NetIncomeSaveEachMonth',
	LastPaidOffCreditCardInFull = 'LastPaidOffCreditCardInFull',
	HomeOwnershipStatus = 'HomeOwnershipStatus',
	NetIncomeSpendOnRentPerMonth = 'NetIncomeSpendOnRentPerMonth',
	StruggledToPayBillsLastYear = 'StruggledToPayBillsLastYear',
	HaveEnoughMoneyToDoThings = 'HaveEnoughMoneyToDoThings',
	FinancialGoalsInLongTerm = 'FinancialGoalsInLongTerm',
	FinancialCovered = 'FinancialCovered',
	WhatRelyOnWhenUnemployed = 'WhatRelyOnWhenUnemployed',
	DependentsYouHave = 'DependentsYouHave',
	InsuranceCoverYouHave = 'InsuranceCoverYouHave',
	SuperContribution = 'SuperContribution',
	CurrentSuperBalance = 'CurrentSuperBalance',
	JobSecurityInCurrentWork = 'JobSecurityInCurrentWork',
	FinanciallyPreparedForRetirement = 'FinanciallyPreparedForRetirement',
	RetirementLivingYouAspireTo = 'RetirementLivingYouAspireTo',
	RetirementLivingYouWillBeAbleToAfford = 'RetirementLivingYouWillBeAbleToAfford',
	FinancialKnowledge = 'FinancialKnowledge',
	MonitorPersonalFinancesFrequency = 'MonitorPersonalFinancesFrequency',
	ResearchFinancialInformationFrequency = 'ResearchFinancialInformationFrequency',
	AttitudeToBuildFinancialKnowledge = 'AttitudeToBuildFinancialKnowledge',
	DocumentedPlans = 'DocumentedPlans',
	UsageOfFinancialAdvisers = 'UsageOfFinancialAdvisers',

	// Business Questions
	JobTitle = 'JobTitle',
	BusinessType = 'BusinessType',
	EmployeeNumber = 'EmployeeNumber',
	BusinessRevenue = 'BusinessRevenue',
	BusinessOperationYears = 'BusinessOperationYears',
	BusinessLifeCycle = 'BusinessLifeCycle',
	BusinessGoalsIn12Months = 'BusinessGoalsIn12Months',
	BusinessAspirations = 'BusinessAspirations',
	ConfidenceInAchievingBusinessGoals = 'ConfidenceInAchievingBusinessGoals',
	Top5ChallengesInBusinessRightNow = 'Top5ChallengesInBusinessRightNow',
	Top5ChallengesPersonallyFaceRightNow = 'Top5ChallengesPersonallyFaceRightNow',
	BusinessProtections = 'BusinessProtections',
	BusinessReviewedInLast2Years = 'BusinessReviewedInLast2Years',
	DocumentedBusinessPlans = 'DocumentedBusinessPlans',
	HaveComplexTaxPlanningNeedsUnderControl = 'HaveComplexTaxPlanningNeedsUnderControl',

	// Wealth Questions
	InvestmentClassesOrAssets = 'InvestmentClassesOrAssets',
	DocumentedWealthPlans = 'DocumentedWealthPlans',
	WealthReviewedInLast2Years = 'WealthReviewedInLast2Years',
	InvestmentPortfolioSizeAndComposition = 'InvestmentPortfolioSizeAndComposition',
	InvestmentPortfolioPerformance = 'InvestmentPortfolioPerformance',
	EffortRequiredToManageInvestments = 'EffortRequiredToManageInvestments',
	ManagingSmsfAdminAndCompliance = 'ManagingSmsfAdminAndCompliance',

	// Estate Questions
	ConsideredFulfilmentOfEstateWishes = 'ConsideredFulfilmentOfEstateWishes',
	EstatePlanningInPlace = 'EstatePlanningInPlace',
	LegallyBindingPlans = 'LegallyBindingPlans'
}

export enum ItemIcons {
	GoSomewhere = 'GoSomewhere',
	GoGetter = 'GoGetter',
	GettingThere = 'GettingThere',
	GettingBy = 'GettingBy'
}

export enum GoalType {
	Short,
	Medium,
	Long
}

export enum NetWealthType {
	Asset,
	Liability
}

export enum IncomeAndExpensesType {
	Income,
	Expense
}

export enum IncomeCategories {
	Salary = 'Salary or salary equivalent',
	Cash = 'Cash or cash equivalent',
	Investments = 'Investments'
}

export enum ExpenseCategories {
	Home = 'Home expenses',
	Investments = 'Related to investments',
	Insurance = 'Insurance expenses',
	MotorVehicle = 'Motor vehicle expenses',
	Tax = 'Tax expenses',
	Other = 'Other expenses'
}

export enum GridCellTypes {
	Date,
	Money,
	YesOrNo,
	SemicolonDelimited,
	FullName,
	FullNameAndEmail,
	Link,
	Percentage,
	FamilyMember,
	RightAlignedNumber
}

export enum NotificationPermissionStatus {
	Default = 'default',
	Granted = 'granted',
	Denied = 'denied'
}

export enum SubscriptionLevels {
	GoingSomewhere,
	GoGetter,
	GettingThere,
	GettingBy
}

export enum PaymentStatus {
	Succeeded = 'succeeded',
	Processing = 'processing',
	Failed = 'failed',
	Canceled = 'canceled'
}

export enum SideMenuItemButtons {
	LogOut = 'logout',
	Switch = 'switch',
	ExternalLink = 'externalLink'
}

export enum SignUpV2Forms {
	SignUpForm,
	PasswordForm,
	OfficeAndPartnerForm,
	SignUpCompletionForm
}

export enum LoginFlowSubPages {
	InitialLoginPage,
	LoginFormPage,
	MobileNumberConfirmationPage,
	SmsVerificationPage,
	BiometricLoginFailedPage,
	LoggedOutPage
}

export enum BiometricLoginSetupFlowSubPages {
	VerifyPasswordSubPage,
	SetupInitialSubPage,
	SetupSuccessfulSubPage,
	SetupFailedSubPage
}

export enum ForgotPasswordFlowForms {
	ForgotPasswordForm,
	ForgotPasswordSuccessForm
}

export enum ResetPasswordFlowForms {
	ResetPasswordForm,
	ResetPasswordSuccessForm
}

export enum UserProfilePages {
	UserProfilePage,
	SmsVerificationPage,
	AuthenticatorApp2FaPage
}

export enum HealthClubSubPages {
	Connect,
	Club
}

export enum HabitTrackerSubPages {
	Welcome,
	Tasks
}

// Should keep the same as API ApiResultMessages
export enum ApiResultMessages {
	GeneralRetryMessage = 'Something went wrong, please try again later.',
	TimeoutOrUnauthorised = 'Unauthorised or timeout',
	SmsVerificationUnexpectedError = 'Verify sms code error',
	ClientAccountLocked = 'Your account has been locked',
	InvoiceFileNotFound = 'Invoice file not found, please contact your client director',
	UnauthorizedLogin = "Either the email or password you entered didn't match our records, please try again.",
	AccountAwaitingApproval = 'Account awaiting approval',
	AccountAlreadyExists = 'Account already exists'
}

export enum NotificationStatus {
	New = 'New',
	Pushed = 'Pushed',
	Read = 'Read',
	Deleted = 'Deleted'
}

export enum ReadingListItems {
	Investor = 'Investor Reading List',
	Business = 'Business Reading List',
	Brett = "Brett's Reading List"
}

// Need to keep the same value as in db offices table country column for the API to work correctly
export enum UserOfficeCountries {
	AU = 'Australia',
	US = 'USA',
	UK = 'United Kingdom',
	HK = 'Hong Kong',
	IE = 'Ireland',
	IN = 'India',
	PH = 'Philippines'
}

export enum DashboardTabItems {
	Dashboard = 'Dashboard',
	Personal = 'Healthy',
	Wealth = 'Wealthy',
	Wisdom = 'Wise',
	Contact = 'Contact'
}

export enum BetterOffDashboardTabItems {
	Dashboard = 'Dashboard',
	Healthy = 'Healthy',
	Wealthy = 'Wealthy',
	Wise = 'Wise'
}

export enum FinancialFlightPlanTabItems {
	Score = 'Score',
	Improve = 'Improve'
}

export enum HealthClubTabItems {
	Day = 'Day',
	Week = 'Week',
	Month = 'Month',
	HalfYear = '6 Month',
	Year = 'Year'
}

export enum LibraryTabItems {
	Business = 'Business',
	Investor = 'Investor',
	Brett = 'Brett Kelly'
}

export enum BbocTabItems {
	Score = 'Score',
	TakeAction = 'Take Action'
}

export enum HabitTrackerTabItems {
	Progress = 'Progress',
	Goals = 'Goals'
}

export enum DocumentVaultSubPages {
	WelcomeSubPage,
	SetupPinSubPage,
	ConfirmPinSubPage,
	EnterPinSubPage,
	DocumentVaultSubPage
}

export enum DocumentExchangeItems {
	Received = 'Received',
	MyUploads = 'My Uploads'
}

export enum DocumentDetailItems {
	Document = 'Document',
	Comments = 'Comments'
}

export enum EventDetailItems {
	Home = 'Home',
	Agenda = 'Agenda',
	Network = 'Network',
	Social = 'Social'
}

export enum EventSessionItems {
	Details = 'Details',
	Notes = 'Notes',
	QA = 'Q&A'
}

export enum CommunityItems {
	Marketplace = 'Marketplace',
	SocialFeed = 'Social Feed',
	Experiences = 'Experiences'
}

export enum MessagesItems {
	Alerts = 'Notifications',
	Chat = 'Chat'
}

export enum InvestmentTabItems {
	Accounts = 'Accounts',
	Investments = 'Investments',
	Advisors = 'Advisors'
}

export enum TradingTabItems {
	Shares = 'Shares',
	BuyShares = 'Buy Shares',
	Resources = 'Resources'
}

export enum BenefitOfferTabItems {
	Health = 'Health',
	Wealth = 'Wealth',
	Wisdom = 'Wisdom',
	Fun = 'Fun'
}

export enum EapTabItems {
	Wellness = 'Wellness',
	Counselling = 'Counselling',
	Resources = 'Resources'
}

export enum PersonalFirmGoalTabItems {
	Personal = 'Personal Goals',
	Firm = 'Firm Goals'
}

export enum InnovationHubTabItems {
	Challenge = 'The Challenge',
	Submission = 'Submission',
	ReadMe = 'Read Me'
}

export enum AdminChecklistFilterItems {
	All = 'All',
	InProgress = 'In Progress',
	Completed = 'Completed'
}

export enum BookCategory {
	KellyPartners = 'Kelly+Partners',
	Personal = 'Personal',
	Business = 'Business'
}

export enum FunFinancePresentationCategory {
	Health = 'Health',
	Wealth = 'Wealth',
	Wisdom = 'Wisdom'
}

export enum ReferralAndCareerTabItems {
	Referrals = 'Referrals',
	OpenRoles = 'Open Roles'
}
